import 'core-js/actual/array/find-last-index.js';
import 'core-js/actual/object/has-own.js';

if (typeof TextEncoder !== 'undefined' && !TextEncoder.prototype.encodeInto) {
  Object.defineProperty(TextEncoder.prototype, 'encodeInto', {
    configurable: true,
    writable: true,
    value(this: TextEncoder, source: string, destination: Uint8Array) {
      const bytes = this.encode(source);
      if (bytes.length <= destination.length) {
        destination.set(bytes);
        return { read: source.length, written: bytes.length };
      }

      let read = 0;
      let written = 0;
      for (const character of source) {
        const encoded = this.encode(character);
        if (written + encoded.length > destination.length) break;
        destination.set(encoded, written);
        read += character.length;
        written += encoded.length;
      }
      return { read, written };
    },
  });
}
